module.exports = __webpack_public_path__ + "img/i-bg.93122b67.gif";